import { render, staticRenderFns } from "./BdUser.vue?vue&type=template&id=4c65dbd2&"
import script from "./BdUser.vue?vue&type=script&lang=js&"
export * from "./BdUser.vue?vue&type=script&lang=js&"
import style0 from "./BdUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports